// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {DropMenuEl} from 'common/components/drop-menu';
import {ItemsMenuEl} from 'common/components/items-menu';
import {PropertiesMenuEl} from 'common/query-builder/query-block/properties-menu/panel';
import {IncludeCustomPropertyType} from 'common/query-builder/query-block/properties-menu/types';
import {Directions} from 'common/components/drop-menu/types';

import type {ContextMenu} from './index';

export function template(this: ContextMenu) {
  const position = this.params.position;
  return (
    <div sel='.mp-context-menu-wrapper'>
      {this.params.open ? (
        <div
          sel='.mp-context-menu'
          style={
            position && {
              position: `absolute`,
              left: `${position.left}px`,
              top: `${position.top}px`,
            }
          }
          hook={{insert: this.helpers.inserted}}
        >
          {/*because mp-context-menu is a hack that yanks .mp-context-menu to body level*/}
          <style>{this.helpers.getCss()}</style>
          <DropMenuEl
            attrs={{
              open: this.params.open,
              'experimental-positioning': true,
              direction: Directions.Right,
            }}
            on={{
              change: this.helpers.handleDropMenuChange,
              click: (ev) => ev.stopPropagation(),
            }}
            props={{
              positionParent: this.state.positionParent,
            }}
          >
            {this.state.secondaryAction === `breakdown` ? (
              <PropertiesMenuEl
                disabledItems={this.helpers.breakdownDisabledItemsMap()}
                eventNames={[this.params.breakdownEvent]}
                open={this.params.open}
                projectId={this.params.projectId}
                workspaceId={this.params.workspaceId}
                includeCustomProperties={IncludeCustomPropertyType.All}
                showBorrowedProperties
                descriptionEditDisabled
                onSelect={this.helpers.handleBreakdownMenuSelect}
              />
            ) : (
              <ItemsMenuEl
                sel='.context-menu-options'
                attrs={{'experimental-positioning': true}}
                on={{
                  click: (ev) => ev.stopPropagation(),
                  clickItem: this.helpers.handleContextMenuSelect,
                }}
                props={{
                  keydownProxyEl: document.body,
                  sections: [{items: this.helpers.menuItems()}],
                }}
              />
            )}
          </DropMenuEl>
        </div>
      ) : null}
    </div>
  );
}
